var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button",class:[
			{
				uppercase: _vm.uppercase,
				block: _vm.block,
				primary: _vm.primary,
				left: _vm.left,
				right: _vm.right,
				flat: _vm.flat,
				filled: _vm.filled,
				disabled: _vm.disabled,
				color: _vm.color,
				tall: _vm.tall,
				custom: _vm.custom,
				toolbar: _vm.toolbar,
				bg: _vm.bg,
				outline: _vm.outline,
				secondary: _vm.secondary,
				pill: _vm.pill
			}
		],style:({
			background: _vm.realBG,
			color: _vm.realColor,
			height: _vm.height,
			margin: _vm.margin
		}),on:{"click":function($event){if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }return _vm.handleClick($event)},"mouseenter":function($event){_vm.hover = true},"mouseleave":function($event){_vm.hover = false}}},[(_vm.hasTooltip)?_c('div',{ref:"tooltipWrapper",class:['button-tooltip-wrapper', { left: _vm.left, right: _vm.right }]},[_c('span',{ref:"tooltip",class:[
					'button-tooltip',
					_vm.hover ? 'button-tooltip-active' : 'button-tooltip-idle',
					_vm.top ? 'top' : 'bottom',
					{ noSlide: _vm.noSlide }
				],style:([
					{
						'transition-delay': _vm.delay,
						'transition-duration': _vm.duration,
						'transition-timing-function': _vm.timing,
						opacity: _vm.debug && !_vm.hover ? '1' : '',
						'font-weight': _vm.noBold ? '500' : '600'
					}
				])},[_vm._v(_vm._s(_vm.tooltip))])]):_vm._e(),(_vm.$slots.default)?_vm._t("default"):_c('div',{staticClass:"button-interior"},[(_vm.label.length)?_c('span',{style:(_vm.computedLabelStyle())},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),(_vm.icon.length || _vm.prefixIcon.length)?_c('Icon',{class:{ prefixIcon: _vm.prefixIcon },attrs:{"size":_vm.iconSize,"name":_vm.icon || _vm.prefixIcon}}):_vm._e()],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }